export const PEG_BOARD_SELECTION_WINDOW_MIN = 4;
export const PEG_BOARD_SELECTION_WINDOW_MAX = 16;
export const PEG_BOARD_SELECTION_WINDOW_DEFAULT = 6;

export const PEG_BOARD_QUEUE_RETURN_RANDOM = 'random';
export const PEG_BOARD_QUEUE_RETURN_WINNERS_FIRST = 'winners_first';

export const PEG_BOARD_QUEUE_RETURN_OPTIONS = [
  {
    value: PEG_BOARD_QUEUE_RETURN_WINNERS_FIRST,
    label: 'Winners first — winning pair ahead of losers, shuffled within each pair',
  },
  { value: PEG_BOARD_QUEUE_RETURN_RANDOM, label: 'Random — all four players shuffled' },
];

export const PEG_BOARD_SELECTION_WINDOW_OPTIONS = Array.from(
  { length: PEG_BOARD_SELECTION_WINDOW_MAX - PEG_BOARD_SELECTION_WINDOW_MIN + 1 },
  (_, i) => {
    const value = String(PEG_BOARD_SELECTION_WINDOW_MIN + i);
    return { value, label: value };
  }
);

export const PEG_BOARD_GAME_ALGORITHM_MANUAL = 'peg_board_manual';
export const PEG_BOARD_GAME_ALGORITHM_RANDOM = 'peg_board_random';

export const clampPegBoardSelectionWindow = (value) => {
  const parsed = parseInt(value, 10);
  if (!Number.isFinite(parsed)) return PEG_BOARD_SELECTION_WINDOW_DEFAULT;
  return Math.min(
    PEG_BOARD_SELECTION_WINDOW_MAX,
    Math.max(PEG_BOARD_SELECTION_WINDOW_MIN, parsed)
  );
};

export const normalizePegBoardQueueReturn = (value) =>
  value === PEG_BOARD_QUEUE_RETURN_RANDOM
    ? PEG_BOARD_QUEUE_RETURN_RANDOM
    : PEG_BOARD_QUEUE_RETURN_WINNERS_FIRST;

export const pegBoardPersistFields = (config = {}) => ({
  peg_board_selection_window: clampPegBoardSelectionWindow(config.peg_board_selection_window),
  peg_board_queue_return: normalizePegBoardQueueReturn(config.peg_board_queue_return),
});
